import styled from "styled-components";

export const MainContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
export const BackButton = styled.span`
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  padding: 10px;
  border: 1px solid;
  margin-left: 20px;
  &:hover {
    color: red;
  }
`;

export const ArticleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  padding: 0px 20px;
`;

export const Title = styled.p`
  font-size: 24px;
  color: #fff;
  text-align: center;
  /* width: 45%; */
  margin-bottom: 20px;
`;

export const Author = styled.span`
  font-size: 18px;
  color: #fff;
  font-style: italic;
  margin-bottom: 20px;
`;

export const Article = styled.p`
  font-size: 16px;
  color: #fff;
  /* width: 50%; */
  text-align: justify;
  font-style: italic;
  max-width: 800px;
  width: 95%;
  /* @media (max-width: 750px) {
    width: 90%;
  } */
`;
